import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <IndexSection />
        <RankingSection />
        <TopicsSection />
        <CommentsSection />
        <ContactSection />
        <FaqSection />
        <UpdatesSection />
        <FeaturesSection />
        <AboutSection />
        <MediaSection />
        <CardsSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}